import {createAjv} from '@jsonforms/core';
import {materialCells, materialRenderers} from '@jsonforms/material-renderers';
import {JsonForms} from '@jsonforms/react';
import {useMemo} from 'react';
import {
  customerRenderesHelper,
  getScopesofAllElements
} from './jsonFormsHelper';
import {LayoutTester} from './testers';
// controllers
import {HorizontalLayout, VerticalLayout} from '@/components/layouts';

import isEqual from 'lodash-es/isEqual';

export default function JsonFormsWrapper({
  jsonschema,
  uischema,
  data = {},
  onChange = () => null,
  readonly = false,
  config = {}
}) {
  const scopeAndCompsList = useMemo(
    () => getScopesofAllElements(uischema),
    [uischema]
  );

  const customRenderers = useMemo(
    () => customerRenderesHelper(scopeAndCompsList, data),
    [scopeAndCompsList, data]
  );

  const onJsonFormsDataChange = (values, errors) => {
    const isSameContent =
      Object.keys(data).length > 0 ? isEqual(values, data) : false;
    if (
      typeof values === 'object' &&
      Object.keys(values).length &&
      !isSameContent
    ) {
      onChange(values, errors);
    }
  };

  const renderers = useMemo(
    () => [
      ...materialRenderers,
      ...customRenderers,
      {
        tester: LayoutTester('VerticalLayout'),
        renderer: VerticalLayout
      },
      {
        tester: LayoutTester('HorizontalLayout'),
        renderer: HorizontalLayout
      }
    ],
    [customRenderers]
  );
  const handleDefaultsAjv = createAjv({useDefaults: true});
  return (
    <JsonForms
      readonly={readonly}
      schema={jsonschema}
      uischema={uischema}
      data={data}
      renderers={renderers}
      cells={materialCells}
      onChange={({errors, data}) => onJsonFormsDataChange(data, errors)}
      ajv={handleDefaultsAjv}
      config={{...config, readonly}}
    />
  );
}
